import * as Route from '../utils/serverRoutes';
import { transformResponseCollection } from '../utils/helpers';
import makeRequest from '../utils/makeRequest';

const financialFile = {
  state: {
    collection: [],
    uploading: false,
    uploadingFile: false,
  },
  reducers: {
    fetchFinancialFilesReducer(state, { collection }) {
      return { ...state, collection };
    },
    updateAttributeReducer(state, payload) {
      return { ...state, ...payload };
    },
    addFinancialFileReducer(state, payload) {
      return { ...state, collection: [...state.collection, payload] };
    },
    removeFinancialFileReducer(state, { id }) {
      const collection = state.collection.filter((e) => e.id !== id);

      return { ...state, collection };
    },
  },
  effects: (dispatch) => ({
    fetchFinancialFiles(bmcId) {
      dispatch.financialFile.updateAttributeReducer({ uploading: true });

      makeRequest({
        dispatch,
        url: Route.financialFiles(bmcId),
        success: (response) => {
          dispatch.financialFile.fetchFinancialFilesReducer({
            collection: transformResponseCollection(response.data.data),
          });
        },
        finish: () => {
          dispatch.financialFile.updateAttributeReducer({ uploading: false });
        },
      });
    },
    addFinancialFile(file, state) {
      dispatch.financialFile.updateAttributeReducer({ uploadingFile: true });

      const formData = new FormData();
      formData.append('financial_file[file]', file);

      makeRequest({
        dispatch,
        method: 'post',
        data: formData,
        url: Route.financialFiles(state.bmc.current.id),
        finish: () => {
          dispatch.financialFile.updateAttributeReducer({
            uploadingFile: false,
          });
        },
      });
    },
    removeFinancialFile({ id }, state) {
      makeRequest({
        method: 'delete',
        url: Route.financialFile(state.bmc.current.id, id),
        success: () => {
          dispatch.financialFile.removeFinancialFileReducer({ id });
        },
      });
    },
  }),
};

export default financialFile;
